<template>
    <div :class="$style['share-css-t']">
        <div :class="$style['share-css']">
            <div :class="$style['headerImage']">
                <img src="../assets/image/cluna/ic_share_background.png" alt=""/>
            </div>
        </div>
        <div :class="$style['css-top-code']">
            <div :class="$style['css-code']">
                <span>با استفاده از کد معرفی خود، اپلیکیشن کلانا را دوستانتان به اشتراک بگذارید و اعتبار رایگان دریافت نمائید</span>
            </div>
            <div :class="$style['shareInfoDetail']">
                <div :class="$style['itemShareInfo']">
                    <span :class="$style['detailInfo']">{{ user.user_invites }}</span>
                    <span>تعداد دعوت</span>
                </div>
                <div :class="$style['itemShareInfo']">
        <span :class="$style['detailInfo']">{{
          user.user_purchased_invites
        }}</span>
                    <span>دعوت موثر</span>
                </div>
                <div :class="$style['itemShareInfo']">
        <span :class="$style['detailInfo']"
        >{{ user.user_invite_wallet }} <span>تومان</span></span
        >
                    <span>اعتبار کسب شده</span>
                </div>
            </div>

        </div>

        <div :class="$style['btn_registration']">
            <v-btn block color="#7ec352" large role="button" v-ripple @click="copyShareText"
            >برای اشتراک گذاری لمس کنید
            </v-btn>
        </div>

        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                timeout="6000">
            متن اشتراک گذاری در کلیپبورد ذخیره شد

            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" role="button" v-ripple @click="snackbar = false">
                    <v-icon>cancel</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "Share",
        data() {
            return {
                user: "",
                shareText: '',
                snackbar: false,
            };
        },
        methods: {
            copyShareText() {
                let textArea = document.createElement("textarea");
                textArea.value = this.shareText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("Copy");
                textArea.remove();
                this.snackbar = true
            },
        },
        mounted() {
            oracle.axios('setting/getInfo', {"filter_by": "website", "search_by": "share_text"}, (response) => {
                oracle.axios("user/getProfile", null, (res) => {
                    this.user = res.data;
                    let invite_code = res.data.user_share_id
                    this.shareText = (response.data + invite_code);
                });
            })
        },
    };
</script>
<style module>

    .share-css-t .btn_registration {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
    }

    .share-css-t .btn_registration button {
        height: 60px !important;
        border-radius: 0;
        font-size: 15px;
        color: #fff !important;
    }

    .share-css-t .btnShare {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .share-css-t .instore-head {
        z-index: 5;
        position: absolute;
        top: 0;
        left: 0;
    }

    .share-css-t .btnShare textarea {
        height: 100px;
        width: 100%;
        resize: none;
        text-align: center;
    }

    .share-css-t .btnShare button span {
        color: white !important;
        font-weight: bold;
        font-size: 17px;
    }

    .share-css-t .btnShare button {
        width: 100%;
        height: 60px !important;
    }

    .share-css-t .css-top-code {
        position: relative;
        display: flex;
        justify-content: center;
        color: white !important;
    }

    .share-css-t .css-code {
        display: flex;
        padding: 7px 15px 30px 15px;
        background-color: #555555;
        text-align: center;
        align-items: center;
    }

    .share-css-t .css-code span {
        width: 100%;
        color: white;
    }


    .share-css {
        height: 250px;
        width: 100%;
        /*background: #7ec352;*/
        /*margin-top: -60px;*/
        position: relative;
    }

    .share-css .headerImage {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .share-css .headerImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /*opacity: 0.1;*/
    }

    .share-css-t .titleHeaderShare {
        width: 100%;
        height: 100%;
        padding-top: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .share-css-t .titleHeaderShare img {
        width: 150px;
        margin-bottom: 10px;
    }

    .share-css-t .titleHeaderShare h6 {
        font-size: 15px;
        color: #fff;
        text-align: center;
        width: 70%;
        font-weight: normal;
    }

    .share-css-t .shareInfoDetail {
        width: 90%;
        height: 100px;
        position: absolute;
        top: 55%;
        /*background: #fff;*/
        border-radius: 10px;
        /*box-shadow: 0 0 10px -5px #000;*/
        padding: 1em 0.5em;
        margin: 0 auto;
        /*margin-top: -50px;*/
        z-index: 10;
        display: flex;
    }

    .share-css-t .itemShareInfo {
        width: calc(100% / 3);
        /*border-left: 1px solid #9e9e9e;*/
        background-color: #7ec352;
        border-radius: 25px;
        margin: 1px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .share-css-t .itemShareInfo:last-child {
        border: none;
    }

    .share-css-t .itemShareInfo span {
        font-size: 12px;
    }

    .share-css-t .detailInfo {
        color: #ffffff;
        font-size: 20px !important;
    }

    .share-css-t .detailInfo span {
        font-size: 12px !important;
        color: #ffffff;
    }

    .share-css-t .imagesocial {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        overflow: hidden;
    }

    .share-css-t .imagesocial img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .share-css-t .socials {
        margin-top: 2em;
        width: 100%;
        padding: 0 15px;
        height: 50%;
        overflow: auto;
    }

    .share-css-t .itemSocial a span {
        font-size: 10px;
        color: #000;
        padding-top: 10px;
        font-weight: bold;
        text-align: center;
    }

    .share-css-t .itemSocial a {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
